'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.ConfirmationModal', []).directive('rmConfirmationModal', require('./directives/ConfirmationModalDirective'));